const SUBSCRIPTION_GIFT_CONFIG = {
  qualifyingProductIds: [
    8556774490455,
    8556775014743,
    8556775571799,
    8556775407959
  ],

  giftVariantId: 54092177998167
};

(() => {
  const giftPropertyName = '_subscription_welcome_gift';
  const giftPropertyValue = 'true';

  let isUpdatingGift = false;

  function getCartUrl(path) {
    const root = window.Shopify?.routes?.root || '/';
    return `${root}${path}`;
  }

  async function getCart() {
    const response = await fetch(getCartUrl('cart.js'), {
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Could not retrieve the cart.');
    }

    return response.json();
  }

  function isQualifyingSubscription(item) {
    return (
      SUBSCRIPTION_GIFT_CONFIG.qualifyingProductIds.includes(
        Number(item.product_id)
      ) &&
      Boolean(item.selling_plan_allocation)
    );
  }

  function isPromotionalGift(item) {
    return (
      Number(item.variant_id) ===
        Number(SUBSCRIPTION_GIFT_CONFIG.giftVariantId) &&
      item.properties?.[giftPropertyName] === giftPropertyValue
    );
  }

  async function addGift() {
    const response = await fetch(getCartUrl('cart/add.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: SUBSCRIPTION_GIFT_CONFIG.giftVariantId,
            quantity: 1,
            properties: {
              [giftPropertyName]: giftPropertyValue
            }
          }
        ]
      })
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.description || 'Could not add the gift tin.');
    }
  }

  async function changeGiftQuantity(lineKey, quantity) {
    const response = await fetch(getCartUrl('cart/change.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: lineKey,
        quantity
      })
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.description || 'Could not update the gift tin.');
    }
  }

  async function synchroniseSubscriptionGift() {
    if (isUpdatingGift) return;

    isUpdatingGift = true;

    try {
      const cart = await getCart();

      const hasQualifyingSubscription = cart.items.some(
        isQualifyingSubscription
      );

      const giftLines = cart.items.filter(isPromotionalGift);

      if (hasQualifyingSubscription && giftLines.length === 0) {
        await addGift();
        refreshCartDisplay();
        return;
      }

      if (!hasQualifyingSubscription && giftLines.length > 0) {
        for (const giftLine of giftLines) {
          await changeGiftQuantity(giftLine.key, 0);
        }

        refreshCartDisplay();
        return;
      }

      if (giftLines.length > 0 && giftLines[0].quantity !== 1) {
        await changeGiftQuantity(giftLines[0].key, 1);
        refreshCartDisplay();
      }

      if (giftLines.length > 1) {
        for (const extraGiftLine of giftLines.slice(1)) {
          await changeGiftQuantity(extraGiftLine.key, 0);
        }

        refreshCartDisplay();
      }
    } catch (error) {
      console.error('[Subscription gift]', error);
    } finally {
      isUpdatingGift = false;
    }
  }

  function refreshCartDisplay() {
    /*
     * Sense cart drawers can differ depending on the theme version.
     * Reloading guarantees the cart count, drawer, discount and subtotal
     * all display the correct state.
     */
    window.location.reload();
  }

  /*
   * Run once when each storefront page loads.
   */
  document.addEventListener('DOMContentLoaded', () => {
    synchroniseSubscriptionGift();
  });

  /*
   * Watch Shopify Ajax cart requests. After the theme adds, removes or
   * updates an item, recheck whether the tin should be present.
   */
  const originalFetch = window.fetch;

  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);

    const request = args[0];
    const url =
      typeof request === 'string'
        ? request
        : request instanceof Request
          ? request.url
          : '';

    const isCartMutation =
      url.includes('/cart/add') ||
      url.includes('/cart/change') ||
      url.includes('/cart/update') ||
      url.includes('/cart/clear');

    const isGiftScriptRequest =
      isUpdatingGift &&
      (
        url.includes('/cart/add') ||
        url.includes('/cart/change')
      );

    if (isCartMutation && !isGiftScriptRequest) {
      setTimeout(() => {
        synchroniseSubscriptionGift();
      }, 300);
    }

    return response;
  };
})();